import gestor from './Views/HomeGestor/state'
import empregado from './Views/HomeEmpregado/state'

export default {
  namespaced: true,
  modules: { gestor, empregado }
}
